import { fetch } from '@/utils/fetch';

// export function getInsideData({ startAt, endAt, isDeal, ifs, wms, orderNo, page, size }) {
// //   let formData = new FormData;
// //   formData.append("page",page);
// //   formData.append("size",size);
// //   formData.append("isDeal",isDeal);
// //   formData.append("ifs",ifs);
// //   formData.append("wms",wms);
// //   formData.append("orderNo",orderNo);
// //   formData.append("startAt",startAt);
// //   formData.append("endAt",endAt);
// //   return fetch({
// //     url: `${process.env.VUE_APP_BASE_URL}/insideDeal/findAll`,
// //     method: 'post',
// //     data: formData
// //   });
// // }

export function getInsideData(formData) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/insideDeal/findAll`,
    method: 'post',
    data: formData
  });
}

export function saveInsideDetail({ orderId, isDeal, launchTime }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/insideDeal/save`,
    method: 'post',
    params: {
      orderId,
      isDeal
    }
  });
}

export function dealInsideDetail({ orderId }) {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/insideDeal/deal`,
    method: 'post',
    params: {
      orderId
    }
  });
}

export function changeStatus({ id }) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/insideDeal/change-inside-status`,
    method: 'post',
    params: {
      id
    }
  })
}

export function getSimpleInsideData() {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/insideDeal/findSimple`,
    method: 'get',
  });
}

export function getSimpleWarning() {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/findSimple`,
    method: 'get',
  });
}

export function getSimpleReminder() {
  return fetch({
    url: `${process.env.VUE_APP_BASE_URL}/reminder/findSimple`,
    method: 'get',
  });
}
